import { Component, OnInit, Output } from "@angular/core";
import { Orgstyle } from "../orgaccount/orgstyle/model/orgstyle";
import { SessionHelper } from "@src/app/helpers/sessionHelper";
import { Meta } from "@angular/platform-browser";
import { PlanningService } from "./service/planning.service";
import { Personorg } from "./model/personorg";
import { firstValueFrom } from "rxjs";
import { Projectperson } from "@src/app/models/projectperson";
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: "app-planning",
  templateUrl: "./planning.component.html",
  styleUrls: ["./planning.component.css"],
})
export class PlanningComponent implements OnInit {
  @Output() orgstyle: Orgstyle;
  @Output() data: any[];
  @Output() people: Personorg[];
  today: Date;
  year: number;
  month: number;
  monthName: string;
  pp:Projectperson[];
  loading: boolean;

  constructor(private meta: Meta, private ws: PlanningService, private uieventhub:UieventhubService,
  ) {}

 async ngOnInit() {
 //this.uieventhub.addLoader('planning');
    this.loading = true;
    //get current year and month
    this.today = new Date();
    // get month name in english
    this.monthName = this.today.toLocaleString('en-us', { month: "long" });
    this.year = this.today.getFullYear();
   //console.log(this.year);
    this.month = this.today.getMonth();
    //console.log(this.month);
    this.data = [];
    //the people
    this.people = [];
    this.pp = [];
    //this.people = JSON.parse(SessionHelper.getPersonOrgs());
    try {
      let pdata = await firstValueFrom(this.ws.getList(SessionHelper.getChoosenOrg()));
      this.people = pdata;
      for await (let person of this.people) {
        let ppdata = await firstValueFrom(this.ws.getPersonProjects(person.personId));
        this.pp = this.pp.concat(ppdata);
      };
      //console.log('pp',this.pp);
      this.makeMonth(this.year, this.month);

    } catch (error) {
      console.error(error.message);
    }
    // this.ws.getList(SessionHelper.getChoosenOrg()).pipe(untilDestroyed(this)).subscribe((data) => {
    //   this.people = data;
    //   //for each person get the personprojects
    //   this.people.forEach((person) => {
    //     this.ws.getPersonProjects(person.personId).pipe(untilDestroyed(this)).subscribe((pp) => {
    //       this.pp.concat(pp);
    //     });
    //   });
    //   this.makeMonth(this.year, this.month);
    // });

    //make current month

    this.meta.addTags([
      { name: "robots", content: "noindex" },
      { name: "googlebot", content: "noindex" },
    ]);
    this.orgstyle = new Orgstyle();
    this.orgstyle.sidenav = "top";
    if (
      SessionHelper.getDynamicStyle() &&
      SessionHelper.getDynamicStyle() !== "undefined"
    ) {
      this.orgstyle = JSON.parse(SessionHelper.getDynamicStyle());
    }
    

  }
  async makeMonth(year: number, month: number) {
    this.data = [];
    for (var i = 1; i <= 31; i++) {
      var date = new Date(year, month, i).getTime();
      if (new Date(year, month, i).getMonth() == month) {
        var daytoadd = {
          Date: date,
        };
        for (let person of this.people) {
          let list = this.pp.filter((p) => {
            return (p.personId == person.personId &&
             new Date(p.start_date).getTime() <= date &&
             new Date(p.end_date).getTime() >= date);
              
            
          });
          //console.log('list',list);
          daytoadd[person.membername] = list.length;
          
          
         

          
        }
        this.data.push(daytoadd);
        //console.log(daytoadd);
        
      }
    }

  }
  //Get projects for a person and filter by date
  // async getProjects(personId: string, date: number) {
  //   //return 10;
  //   this.ws.getPersonProjects(personId).pipe(untilDestroyed(this)).subscribe((pp) => {
  //      //console.log('_start',new Date(pp[0].start_date).getTime());
  //     //console.log('_end',new Date(pp[0].end_date).getTime());
  //      //console.log('_date',new Date(date).toISOString());
  //    //console.log('pp',pp);
  //    let count = pp .length;//.filter((p) => {true
  //    subject.next(count);
  //       //new Date(p.start_date).getTime() <= date //&&
  //        // new Date(p.end_date).getTime() >= date
  //     //}).length;
  //    // if(count.length > 0){
  //     //console.log('count',count);
  //    // }
     
  //  });
  //  return subject;
  // }

  nextMonth() {
   //this.uieventhub.addLoader('planning_next');
    this.loading = true;
    if (this.month == 11) {
      this.month = 0;
      this.year++;
    } else {
      this.month++;
    }
    this.monthName = new Date(this.year, this.month).toLocaleString('en-us', {
      month: "long",
    });
    this.makeMonth(this.year, this.month);
  }
  previousMonth() {
   //this.uieventhub.addLoader('planning_previous');
    this.loading = true;
    if (this.month == 0) {
      this.month = 11;
      this.year--;
    } else {
      this.month--;
    }
    this.monthName = new Date(this.year, this.month).toLocaleString('en-us', {
      month: "long",
    });
    this.makeMonth(this.year, this.month);
  }
  endLoading(done: boolean) {
    this.loading = !done;
   //this.uieventhub.removeLoader('planning_next');
   //this.uieventhub.removeLoader('planning_previous');
   this.uieventhub.removeLoader('planning');
   this.uieventhub.removeLoader('personname');
  }
}
